import { Clipboard } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HandlerMessageService } from 'app/common/services/handler-error/handler-message.service';
import { LanguageService } from 'app/core/i18n/language.service';
import { TranslatePipe } from 'app/core/i18n/translate.pipe';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { BusinessPartnerBySubRoute } from '../../../../interfaces/busines-partner-by-sub-route.interface';

@Component({
  selector: 'app-contact-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule, TranslatePipe],
  templateUrl: './contact-cell-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactCellRendererComponent {
  private clipboard = inject(Clipboard);
  private handlerMessage = inject(HandlerMessageService);
  private i18n = inject(LanguageService);

  readonly params = input.required<CellRendererParams<BusinessPartnerBySubRoute>>();

  readonly data = computed(() => this.params()?.data);

  // Teléfono principal
  readonly phone = computed(() => {
    const principalPhone = this.data()?.principalPhone;
    if (!principalPhone?.phone) return null;
    const prefix = principalPhone.prefix ? `+${principalPhone.prefix} ` : '';
    return `${prefix}${principalPhone.phone}`;
  });

  // Email principal (del contacto principal)
  readonly email = computed(() => {
    const contact = this.data()?.principalContact;
    const principalEmail = contact?.emails?.find((e) => e.isPrincipal) ?? contact?.emails?.[0];
    return principalEmail?.email ?? null;
  });

  // Nombre del contacto
  readonly contactName = computed(() => this.data()?.principalContact?.fullName ?? null);

  copyToClipboard(value: string, type: 'phone' | 'email'): void {
    const success = this.clipboard.copy(value);
    if (success) {
      const key =
        type === 'phone'
          ? 'routing.SUB_ROUTE_PARTNERS.CELLS.CONTACT_COPY_PHONE_SUCCESS'
          : 'routing.SUB_ROUTE_PARTNERS.CELLS.CONTACT_COPY_EMAIL_SUCCESS';
      this.handlerMessage.success({ message: this.i18n.t(key) });
    }
  }
}
